import { useState } from 'react';
import { Button, Modal, Radio } from 'antd';
import '../../FileManagerModals.scss';
import './RestoreTrash.scss';
import { FileNode } from '../../../../../types/FileManagerTypes';
interface RestoreTrashModalProps {
  show: boolean;
  hide: () => void;
  selectedRestoreFiles?: FileNode[];
  restoreFiles: (files: FileNode[], moveToRoot: boolean) => void;
}

export const RestoreTrashModal = ({ show, hide, selectedRestoreFiles, restoreFiles }: RestoreTrashModalProps) => {
  const [moveToRoot, setMoveToRoot] = useState<boolean>(false);

  const handleRestore = () => {
    if (!selectedRestoreFiles) return;
    restoreFiles(selectedRestoreFiles, moveToRoot);
    hide();
  };

  return (
    <Modal
      open={show}
      onCancel={hide}
      centered
      closable={false}
      footer={null}
      width="29.1094rem"
      className="restore-trash-modal"
      rootClassName="restore-trash-modal__root"
    >
      <div className="files__header">
        <div className="files__title restore-modal__title">Where do you want to Restore these Files to?</div>
      </div>
      <Radio.Group buttonStyle="solid" value={moveToRoot} onChange={(e) => setMoveToRoot(e.target.value)} className="restore-radio-group">
        <Radio.Button value={false} className="restore-radio-button">
          Previous Location
        </Radio.Button>
        <Radio.Button value={true} className="restore-radio-button">
          File Manager Home
        </Radio.Button>
      </Radio.Group>
      <div className="file_button-group restore-modal__button-group">
        <Button className="restore-modal__back-button" onClick={hide}>
          Back
        </Button>
        <Button onClick={handleRestore} type="primary" className="restore-modal__restore-button">
          Restore
        </Button>
      </div>
    </Modal>
  );
};
